import React from 'react';
import { getFormattedTime } from '../calendarHelper.js';
import './EventDisplay.css';

// A claimed volunteer shift, rendered instead of EventItem rather than through
// it: EventItem dereferences place_name, _embedded.team and _links.self.href on
// every render, and a shift carries none of those. It borrows EventItem's own
// classes so the two read as one list.
export default class VolunteerItem extends React.PureComponent {
  render() {
    const {event} = this.props;
    const volunteer = event.volunteer || {};
    // Absent whenever the sheet's team has left the pilot. The row then reads
    // as plain text rather than linking somewhere that would only bounce.
    const href = event._links && event._links.self ? event._links.self.href : null;
    const slotName = href ? <a href={href}>{event.title}</a> : <span>{event.title}</span>;
    return (
      <div className="border-bottom py-1">
        <p className="EventTime text-start m-0 px-2">
          {getFormattedTime(event.local_iso8601, event.tzid)}
        </p>
        <div className="EventInfo--container d-flex flex-nowrap EventType volunteer-indicator m-2">
          <div className="col EventInfo">
            <span className="vsAt mb-0">{slotName}</span>
            {volunteer.sheet_title ? <p className="m-0">{volunteer.sheet_title}</p> : null}
            {volunteer.child_name ? <p className="m-0 ChildName">Credited to: {volunteer.child_name}</p> : null}
          </div>
          <div className="text-end d-flex flex-column justify-content-between EventMisc">
            <span>{volunteer.quantity > 1 ? `${volunteer.quantity} spots` : '\xa0'}</span>
            <span className="text-uppercase">Volunteer</span>
          </div>
        </div>
      </div>
    );
  }
}
